import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Common } from '@stockbit/ui';
import { useLivePriceSender } from 'global/Datafeed/UseLivePrice/useLivePriceSender';
import { LivePriceSymbolsKeyEnum } from 'global/Datafeed/UseLivePrice/liveprice.store.types';
import { effects, selectors } from './slice';

import RowWatchlist from './RowWatchlist';
import { TableWatchlistWrapper } from './styled';
import EmptyWatchlist from './EmptyWatchlist';

const { Text } = Common;

const TableWatchlist = ({ watchlistId, setAddSymbol }) => {
  const dispatch = useDispatch();
  const { list } = useSelector(selectors);

  const [closedRow, setClosedRow] = useState<number>();

  useEffect(() => {
    dispatch(effects.getCompanyWatchlist({ watchlistId }));
  }, [dispatch, watchlistId]);

  useLivePriceSender(
    LivePriceSymbolsKeyEnum.SIDE_WIDGET_WATCHLIST,
    list.map(({ symbol }) => symbol),
  );

  if (list.length === 0) {
    return <EmptyWatchlist onAdd={() => setAddSymbol(true)} />;
  }

  return (
    <TableWatchlistWrapper>
      <table style={{ width: '100%' }}>
        <thead>
          <th>
            <Text family="bold" size="11px">
              Symbol
            </Text>
          </th>
          <th>
            <Text family="bold" size="11px" align="right">
              Last
            </Text>
          </th>
          <th>
            <Text family="bold" size="11px" align="right">
              Change (%)
            </Text>
          </th>
        </thead>
        <tbody>
          {list.map((item, index) => (
            <RowWatchlist
              key={item.symbol}
              index={index}
              data={item}
              watchlistId={watchlistId}
              closedRow={closedRow}
              setClosedRow={setClosedRow}
            />
            ))}
        </tbody>
      </table>
    </TableWatchlistWrapper>
  );
};

export default TableWatchlist;
